import styled from 'styled-components';

export const StyledDiv = styled.div`
  padding: 0 40px 40px;

  height: 100%;

  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;
